var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "pim-product-table-list" },
    [
      _c(
        "div",
        { staticClass: "pim-product-table-list__header" },
        _vm._l(_vm.headers, function (title) {
          return _c("div", { staticClass: "pim-product-table-list__title" }, [
            _vm._v("\n            " + _vm._s(title) + "\n        "),
          ])
        }),
        0
      ),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "row" }, [
      _c("div", { staticClass: "pim-product-table-list__hr" }, [_c("hr")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }